var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigureBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4C9.79565 4 10.5587 4.31607 11.1213 4.87868C11.6839 5.44129 12 6.20435 12 7C12 7.79565 11.6839 8.55871 11.1213 9.12132C10.5587 9.68393 9.79565 10 9 10C8.20435 10 7.44129 9.68393 6.87868 9.12132C6.31607 8.55871 6 7.79565 6 7C6 6.20435 6.31607 5.44129 6.87868 4.87868C7.44129 4.31607 8.20435 4 9 4Z",
    fill: "#0D71E5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 2.5,
    stroke: "#0D71E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.5C16 16.026 16 17 16 17C11 17 8 17 2.00001 17C2.00001 17 2 16.026 2 15.5C2 13.0147 5.13401 11 9 11C12.866 11 16 13.0147 16 15.5Z",
    fill: "#0D71E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureBlue);
export default __webpack_public_path__ + "static/media/figure_blue.bf8e3ca8c79e20717e740953c9789648.svg";
export { ForwardRef as ReactComponent };